import classNames from "classnames";
import { NumberBox } from "devextreme-react/number-box";
import get from "lodash/get";
import replace from "lodash/replace";
import React, { memo } from "react";
function NumberWidget({ className, value, onChange, min, max, readOnly, disabled, fieldName, label, ...other }) {
    const textToNumberVal = (text) => parseFloat(replace(text, ",", "."));
    const isValid = (val) => (min === undefined || val >= min) && (max === undefined || val <= max);
    const handleChange = ({ value: newValue, event }) => {
        if (!event || !isValid(newValue) || !onChange)
            return;
        onChange(newValue, fieldName);
    };
    const handleInput = (e) => {
        const val = textToNumberVal(get(e.event, "currentTarget.value", ""));
        if (!isValid(val)) {
            e.component.instance().repaint();
            e.component.instance().focus();
        }
    };
    const handlePaste = (e) => {
        var _a;
        if (!onChange)
            return;
        (_a = e.event) === null || _a === void 0 ? void 0 : _a.preventDefault();
        const clipboardData = get(e.event, "originalEvent.clipboardData");
        if (clipboardData && clipboardData instanceof DataTransfer) {
            const text = clipboardData.getData("Text");
            if (text) {
                const val = textToNumberVal(text);
                isValid(val) && onChange(val, fieldName);
            }
        }
    };
    return (React.createElement(NumberBox, { onValueChanged: handleChange, className: classNames("w-100", className), showSpinButtons: true, valueChangeEvent: "input", onInput: handleInput, onPaste: handlePaste, value: value, min: min, max: max, label: label, labelMode: "floating", spellcheck: false, readOnly: readOnly, disabled: disabled, ...other }));
}
export default memo(NumberWidget);
NumberWidget.defaultProps = {
    min: 0,
    format: "fixedPoint"
};
